import React from 'react';
import { IWorkingDayInfo } from '../../../../interfaces/professional/Professional';
import * as classes from './WorkingDay.module.scss';
import cn from 'classnames';
import { Availability } from '../../../../enums/Availability';

interface Props extends IWorkingDayInfo {
  dayOfWeek: string;
}

const WorkingDay = ({ open, closed, availability, dayOfWeek }: Props) => {
  return (
    <div className={classes.wrapper}>
      <div>
        <span className={cn(classes.marker, availability === Availability.CLOSED && classes.closed)} />
        {dayOfWeek}
      </div>
      <div className={classes.value}>{open && closed ? `${open} - ${closed}` : '-'}</div>
    </div>
  );
};

export default WorkingDay;
